import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { ConverterService, OccEndpointsService } from '@spartacus/core'
import {
  MB_CHECKOUT_CONTACT_DETAILS_NORMALIZER,
  MbCheckoutContactDetailsAdapter
} from '../connectors'
import { MbCheckoutContactDetailsModel } from '../../models'

@Injectable({
  providedIn: 'root',
})
export class MbOccCheckoutContactDetailsAdapter implements MbCheckoutContactDetailsAdapter {

  constructor (protected http: HttpClient,
              protected occEndpoints: OccEndpointsService,
              protected converter: ConverterService) {
  }

  load (cartId: string) {
    return this.http.get(this.getEndpoint(cartId)).pipe(
      this.converter.pipeable(MB_CHECKOUT_CONTACT_DETAILS_NORMALIZER)
    )
  }

  post (form: MbCheckoutContactDetailsModel, cartID: string) {
    form = this.converter.convert(form, MB_CHECKOUT_CONTACT_DETAILS_NORMALIZER)
    return this.http.post(this.getEndpoint(cartID), form)
  }

  protected getEndpoint (cartId: string) {
    return this.occEndpoints.buildUrl(
      'checkoutContactDetails',
      {
        urlParams: { cartId },
      }
    )
  }
}
